import { loadImage } from "client/utils/imageEdit/loadImage";
import { useEffect } from "react";
import { initialState } from "store/features/colorPicker/initialState";
import { colorPickerSelector } from "store/features/colorPicker/selectors/colorPickerSelector";
import type { ColorPickerState } from "store/features/colorPicker/types";
import { useAppSelector } from "store/store";

export const useColorPickerSettings = () => {
    const { source, selectedColor } = useAppSelector(colorPickerSelector, equalityFn);

    useEffect(() => {
        // lazyload the initial image
        loadImage(initialState.image.src);
    }, []);

    return { source, selectedColor };
};

const equalityFn = (left: ColorPickerState, right: ColorPickerState) => {
    if (left.source !== right.source || JSON.stringify(left.selectedColor) !== JSON.stringify(right.selectedColor))
        return false;

    return true;
};
